import {
  supportTicketQueryScopeKey,
  type SupportTicketQueryScope,
} from "./support-ticket-query-keys";

const SUPPORT_TICKET_USER_QUERY_KEY_ROOT = ["supportTicketUsers"] as const;

export type SupportTicketUserQueryScope = SupportTicketQueryScope;

type SupportTicketUserScopeKey =
  | readonly ["account", string]
  | readonly ["team", string]
  | readonly ["unscoped"];

export function supportTicketUserScopeKey(
  scope?: SupportTicketUserQueryScope,
): SupportTicketUserScopeKey {
  return supportTicketQueryScopeKey(scope);
}

export const supportTicketUserQueryKeys = {
  all: SUPPORT_TICKET_USER_QUERY_KEY_ROOT,
  accessibleUsers: (scope?: SupportTicketUserQueryScope) =>
    [
      ...SUPPORT_TICKET_USER_QUERY_KEY_ROOT,
      "accessibleUsers",
      ...supportTicketUserScopeKey(scope),
    ] as const,
};
